import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useAppContext } from 'utils/hooks';
import notFoundImage from 'assets/rr-illustrations/lost.png';
import { ReactComponent as SystemCrashIcon } from 'assets/ss-icons/zero-state-icons/system-crash.svg';

export default function NotFound() {
  const { isSSREnv } = useAppContext();

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>
      <div className={styles.image}>
        <If test={!isSSREnv} otherwise={<SystemCrashIcon className="mt-5" />}>
          <img src={notFoundImage} alt="not found" />
        </If>
      </div>
      <div className={styles.text}>
        Sorry. We couldn’t find what you were looking for.
      </div>
      <Link to="/">
        <UiKit.Button size="md" variant="secondary">
          Back To Home
        </UiKit.Button>
      </Link>
    </div>
  );
}
